import { theme } from '@faxi/web-component-library';
import { flex, fontSize, laptop, mobile } from '@faxi/web-css-utilities';
import { LayoutSection } from 'layouts';
import styled, { css } from 'styled-components';

const StyledCostsSolution = styled(LayoutSection)`
  ${flex('column')};
  gap: ${theme.sizes.SIZE_88};

  .cedolauto-card {
    ${flex('column', 'flex-start', 'center')};

    margin-bottom: 0;

    background-color: var(--BACKGROUND_1_2);
    color: white;

    &__title {
      ${fontSize('20px')};

      ${mobile(css`
        margin: 0 auto !important;
      `)}
    }

    &__description {
      margin: 0;
    }

    &__descriptions__item p {
      width: 100%;
      text-align: center;
    }
  }

  .cedolauto-card ul li:first-of-type p {
    margin-bottom: ${theme.sizes.SIZE_24};
  }

  .cedolauto-is-smart-solution ul li:first-of-type p {
    font-weight: 700;
  }

  .cedolauto-card .cedolauto-card__descriptions__item:not(:last-of-type) {
    margin-bottom: ${theme.sizes.SIZE_4};

    p:has(b) {
      margin-bottom: ${theme.sizes.SIZE_24};
    }
  }

  .cedolauto-costs-solution-section {
    &__subtitle {
      ${fontSize('24px')};
      font-weight: 700;
      text-align: center;

      color: var(--BLUE-01);
    }

    &__cards {
      ${flex('row', 'center')};
      gap: ${theme.sizes.SIZE_40};

      ${laptop(css`
        gap: ${theme.sizes.SIZE_12};
      `)}

      ${mobile(css`
        ${flex('column')};
        gap: ${theme.sizes.SIZE_24};
      `)}
    }
  }
`;

export { StyledCostsSolution };
